<div [formGroup]="form">
    <div class="card-text">
        <div class="row">
            <div class="col-sm-2 bolded">
                {{ "CampDetails.ParentCategory" | translate }}
            </div>
            <div class="col-sm-10">{{ form.controls.parentName.value }}</div>
        </div>
    </div>
    @if (form.controls.name.value) {
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.Category" | translate }}
                </div>
                <div class="col-sm-10">{{ form.controls.name.value }}</div>
            </div>
        </div>
    }
</div>
